import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axios from "../../utils/axios";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useJob } from '../../context/jobContext';
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    InputGroup,
    Badge,
    Input,
    Button,
    Progress,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { FiCircle, FiCheckCircle, FiEdit, FiTrash2, FiEye, FiMoreVertical, FiUpload, FiPlus } from 'react-icons/fi';
import { FaDotCircle } from "react-icons/fa";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";

const JobsApplications = (props) => {
    document.title = "Jobs Management | Equity Circle - Admin Dashboard";
    const breadcrumbItems = [
        { title: "Jobs Management", link: "#" },
        { title: "All Jobs", link: "#" },
    ];

    const navigate = useNavigate();

    useEffect(() => {
        props.setBreadcrumbItems('Jobs Management', breadcrumbItems);
        // fetchJobs();
        fetchApplications();
    }, []);
    const { jobContent, updateJobContent } = useJob();
    const [jobs, setJobs] = useState([]);
    const [applications, setApplications] = useState([]);
    const [filteredApplications, setFilteredApplications] = useState([]);
    const [statusFilter, setStatusFilter] = useState('all');
    const [isLoading, setIsLoading] = useState(true);
    const [selectedJob, setSelectedJob] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const toggleViewModal = () => setViewModal(!viewModal);
    // const fetchJobs = async () => {
    //     try {
    //         const response = await axios.get('/api/jobs?status=');
    //         setJobs(response.data);
    //     } catch (error) {
    //         console.error('Error fetching jobs:', error);
    //     }
    // };

    const updateStatus = async (applicationId, newStatus) => {
        try {
            const response = await axios.put(`/api/job-applications/${applicationId}`, {
                status: newStatus
            });

            toast.success('Application status updated successfully');

            // Refresh the applications list
            fetchApplications();
        } catch (error) {
            console.error('Error updating application status:', error);
            toast.error(error.response?.data?.message || 'Failed to update application status');
        }
    }

    const fetchApplications = async (status = '') => {
        try {
            setIsLoading(true);
            const response = await axios.get(`/api/job-applications${status ? `?status=${status}` : ''}${jobContent?.id ? `?job_id=${jobContent?.id}` : ''}`);
            setApplications(response.data.applications);
            setFilteredApplications(response.data.applications);
        } catch (error) {
            console.error('Error fetching applications:', error);
            toast.error('Failed to load applications');
        } finally {
            setIsLoading(false);
        }
    };

    const handleStatusFilter = (status) => {
        setStatusFilter(status);
        if (status === 'all') {
            fetchApplications();
        } else {
            fetchApplications(status);
        }
    };

    const viewApplication = (application) => {
        setSelectedJob(application);
        toggleViewModal();
    };

    const DeleteJobApplication = async (applicationId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`/api/job-applications/${applicationId}`);

                    toast.success('Application deleted successfully');

                    // Refresh the applications list
                    fetchApplications();
                } catch (error) {
                    console.error('Error deleting application:', error);
                    toast.error(error.response?.data?.message || 'Failed to delete application');
                }
            }
        })
    }

    const backToJob = () => {
        navigate('/jobs-management');
    }

    return (
        <React.Fragment>
            <ToastContainer />
            <Row>
                <Col lg="12">
                    <Card>
                        <CardBody>
                            <Row className="mb-4">
                                <Col md="6">
                                    <h4 className="mb-0">Job Applications</h4>
                                    <p className="text-muted mt-2">Manage and review all job applications</p>
                                </Col>
                                <Col md="6" className="d-flex justify-content-end">
                                    <Input
                                        type="select"
                                        onChange={(e) => handleStatusFilter(e.target.value)}
                                        value={statusFilter}
                                        style={{ maxWidth: '300px', height: 'fit-content' }}
                                    >
                                        <option value="all">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="accepted">Accepted</option>
                                        <option value="rejected">Rejected</option>
                                    </Input>
                                </Col>
                            </Row>

                            <Card className="mb-3" style={{ boxShadow: '0 0 6px 0px #b3b3b3' }}>
                                <CardBody className="p-3">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <h4 className="mb-1">{jobContent?.job_title || 'N/A'}</h4>
                                            <h6 className="text-muted mb-2">{jobContent?.job_subtitle || 'N/A'}</h6>
                                        </div>
                                        <Badge color="primary" className="custom-batch">
                                            {moment(jobContent?.job_create_date).format('MMM D, YYYY')}
                                        </Badge>
                                    </div>

                                    <div className="mb-3">
                                        <p className="mb-2">{jobContent?.job_description || 'No description available'}</p>
                                    </div>

                                    <div className="d-flex flex-wrap gap-3 mb-3">
                                        <div>
                                            <small className="text-muted d-block">Type</small>
                                            <Badge color="info" className="custom-batch">{jobContent?.job_type || 'N/A'}</Badge>
                                        </div>
                                        <div>
                                            <small className="text-muted d-block">Mode</small>
                                            <Badge color="secondary" className="custom-batch">{jobContent?.job_mode || 'N/A'}</Badge>
                                        </div>
                                        <div>
                                            <small className="text-muted d-block">Location</small>
                                            <Badge color="warning" className="custom-batch">
                                                {jobContent?.job_location || 'N/A'}
                                            </Badge>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center border-top pt-3">
                                        <div>
                                            <small className="text-muted d-block">Salary Range</small>
                                            <h5 className="mb-0">
                                                {jobContent?.job_currency || '$'}
                                                {jobContent?.job_min_salery || '0'} - {jobContent?.job_currency || '$'}
                                                {jobContent?.job_max_salery || '0'}
                                            </h5>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center gap-2">
                                            <Button color="secondary" size="sm" onClick={backToJob}>
                                                Back to Jobs
                                            </Button>
                                            <Button color="primary" size="sm">
                                                View Details
                                            </Button>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>

                            <Table>
                                <thead>
                                    <tr>
                                        <th>Job Title</th>
                                        <th>Job ID</th>
                                        <th>Status</th>
                                        <th>Applicant Name</th>
                                        <th>Applicant Email</th>
                                        <th>Applicant Phone</th>
                                        <th>Applicant Resume</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-4">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : applications.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-4">
                                                No applications found
                                            </td>
                                        </tr>
                                    ) : (
                                        applications.map((application) => (
                                            <tr key={application.id}>
                                                <td>{application.job_title ?? 'N/A'}</td>
                                                <td>{application.job_id ?? 'N/A'}</td>
                                                <td>
                                                    <Badge
                                                        color={
                                                            application?.status === 'accepted' ? 'success' :
                                                                application?.status === 'rejected' ? 'danger' :
                                                                    'warning'
                                                        }
                                                        className="text-uppercase custom-batch"
                                                    >
                                                        {application?.status ?? 'N/A'}
                                                    </Badge>
                                                </td>
                                                <td>{application?.user?.name ?? 'N/A'}</td>
                                                <td>{application?.user?.email ?? 'N/A'}</td>
                                                <td>{application?.user?.phone ?? 'N/A'}</td>
                                                <td>
                                                    <a href={application.cv_file_path_url} target="_blank" rel="noopener noreferrer">
                                                        <FiEye /> View Resume
                                                    </a>
                                                </td>
                                                <td className="d-flex gap-2">
                                                    <Button color="primary" className='p-1 px-2' onClick={() => viewApplication(application?.job)}>
                                                        <FiEye size={16} />
                                                    </Button>
                                                    <Button color="danger" className='p-1 px-2' onClick={() => DeleteJobApplication(application.id)}>
                                                        <FiTrash2 size={16} />
                                                    </Button>
                                                    <Dropdown isOpen={application.id === dropdownOpen} toggle={() => setDropdownOpen(application.id === dropdownOpen ? null : application.id)}>
                                                        <DropdownToggle color="light" className="text-capitalize p-1 px-2">
                                                            <FiMoreVertical size={16} />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem header>Update Status</DropdownItem>
                                                            <DropdownItem
                                                                className={application.status === 'pending' ? 'active' : ''}
                                                                onClick={() => updateStatus(application.id, 'pending')}
                                                            >
                                                                <Badge color="warning" className="w-100 text-left">Pending</Badge>
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                className={application.status === 'accepted' ? 'active' : ''}
                                                                onClick={() => updateStatus(application.id, 'accepted')}
                                                            >
                                                                <Badge color="success" className="w-100 text-left">Accepted</Badge>
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                className={application.status === 'rejected' ? 'active' : ''}
                                                                onClick={() => updateStatus(application.id, 'rejected')}
                                                            >
                                                                <Badge color="danger" className="w-100 text-left">Rejected</Badge>
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={viewModal} toggle={toggleViewModal} size="lg">
                <ModalHeader toggle={toggleViewModal}>Job Details</ModalHeader>
                <ModalBody>
                    {selectedJob && (
                        <div>
                            <Row>
                                <Col lg="12" className="text-center mb-3">
                                    <img
                                        src={selectedJob.main_image_url}
                                        alt={selectedJob.title}
                                        className="img-fluid rounded"
                                        style={{ maxHeight: '200px' }}
                                    />
                                </Col>

                                <Col lg="12">
                                    <h3>{selectedJob.title}</h3>
                                    <h5 className="text-muted">{selectedJob.subtitle}</h5>
                                    <p className="text-muted">
                                        <FaDotCircle className="mr-1" />
                                        {selectedJob.location}, {selectedJob.country} | {selectedJob.job_type} | {selectedJob.job_mode}
                                    </p>

                                    <div className="my-3">
                                        <h5>Salary</h5>
                                        <p>
                                            {selectedJob.currency}{selectedJob.min_salary} - {selectedJob.currency}{selectedJob.max_salary}
                                            {selectedJob.plus_extra && ` + ${selectedJob.plus_extra}`}
                                        </p>
                                    </div>

                                    <div className="my-3">
                                        <h5>Experience Level</h5>
                                        <p>{selectedJob.experience}</p>
                                    </div>

                                    <div className="my-3">
                                        <h5>Short Description</h5>
                                        <p>{selectedJob.short_description}</p>
                                    </div>

                                    {selectedJob.custom_sections && JSON.parse(selectedJob.custom_sections).map((section, index) => (
                                        <div key={index} className="my-3">
                                            <h5>{section.title}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: section.description }} />
                                        </div>
                                    ))}

                                    <div className="mt-4">
                                        <small className="text-muted">
                                            Posted on: {moment(selectedJob.created_at).format('MMMM D, YYYY')}
                                        </small>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleViewModal}>Close</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}


export default connect(null, { setBreadcrumbItems })(JobsApplications);